/**
 * @generated SignedSource<<c0c8322f91566b028178587b7499aa8f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "AdminPage_query";
};
export type AdminPage_query$key = {
  readonly " $data"?: AdminPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bc4b01c1056315ac299c45959f7102c6";

export default node;
